import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const InfoFill = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <g fillRule="nonzero">
        <path d="M 9.5 0 C 4.253 0 0 4.253 0 9.5 S 4.253 19 9.5 19 s 9.5 -4.253 9.5 -9.5 S 14.747 0 9.5 0 z M 9 4 c 0.552 0 1 0.448 1 1 s -0.448 1 -1 1 s -1 -0.448 -1 -1 s 0.448 -1 1 -1 z m 3 11 H 7 v -1 h 2 V 8 H 7 V 7 h 3 v 7 h 2 v 1 z"></path>
      </g>
    </g>
  </SvgIcon>
);

export default InfoFill;
